/* SQUISH RITUAL – Produktseite: Varianten, Menge, Galerie, Sticky ATC. */
(function () {
  "use strict";
  document.querySelectorAll("[data-product]").forEach(function (root) {
    var data = root.querySelector("[data-variants-json]");
    var variants = data ? JSON.parse(data.textContent) : [];
    var idInput = root.querySelector("[data-variant-id]");
    var priceEl = root.querySelector("[data-price]");
    var compareEl = root.querySelector("[data-compare]");
    var availEl = root.querySelector("[data-availability]");
    var btn = root.querySelector("[data-add-to-cart]");
    var stickyBtn = root.querySelector("[data-sticky-add]");
    var stickyPrice = root.querySelector("[data-sticky-price]");
    var stickyVariant = root.querySelector("[data-sticky-variant]");
    var stickyThumb = root.querySelector("[data-sticky-thumb]");
    var atcPrice = root.querySelector("[data-atc-price]");
    var savingEl = root.querySelector("[data-saving]");
    var qtyInput = root.querySelector("[data-qty]");
    var selected = {};
    root.querySelectorAll("[data-option-chip][aria-checked='true'], [data-option-chip][aria-pressed='true']").forEach(function (c) { selected[c.dataset.option] = c.dataset.value; });

    function money(cents) {
      var fmt = (window.Shopify && window.Shopify.money_format) || "{{amount_with_comma_separator}} €";
      var s = (cents / 100).toFixed(2);
      return fmt.replace("{{amount}}", s).replace("{{amount_with_comma_separator}}", s.replace(".", ",")).replace("{{amount_no_decimals}}", String(Math.round(cents / 100)));
    }
    function current() {
      var names = Object.keys(selected);
      if (!names.length) return variants[0];
      return variants.find(function (v) {
        return names.every(function (n, i) { return v.options[i] === selected[n] || (v.optionNames && v.optionNames[n] === selected[n]); });
      }) || variants.find(function (v) { return v.options.indexOf(selected[names[0]]) >= 0; }) || variants[0];
    }
    function update() {
      var v = current();
      if (!v) return;
      if (idInput) idInput.value = v.id;
      if (priceEl) priceEl.textContent = money(v.price);
      var onSale = v.compare_at_price && v.compare_at_price > v.price;
      if (compareEl) { if (onSale) { compareEl.textContent = money(v.compare_at_price); compareEl.hidden = false; } else compareEl.hidden = true; }
      if (savingEl) { if (onSale) { savingEl.textContent = savingEl.dataset.label + " " + money(v.compare_at_price - v.price) + " (" + Math.round(((v.compare_at_price - v.price) / v.compare_at_price) * 100) + " %)"; savingEl.hidden = false; } else savingEl.hidden = true; }
      if (atcPrice) atcPrice.textContent = money(v.price);
      if (stickyVariant) stickyVariant.textContent = variants.length > 1 ? v.title + " · " : "";
      if (stickyThumb && v.featured_image && v.featured_image.src) stickyThumb.src = v.featured_image.src;
      root.querySelectorAll("[data-option-selected]").forEach(function (el) { var fs = el.closest("fieldset"); var chip = fs && fs.querySelector("[data-option-chip][aria-checked='true']"); if (chip) el.textContent = chip.dataset.value; });
      if (availEl) { availEl.textContent = v.available ? availEl.dataset.available : availEl.dataset.soldOut; availEl.classList.toggle("out", !v.available); }
      if (btn) { btn.disabled = !v.available; btn.textContent = v.available ? btn.dataset.label : btn.dataset.soldOut; }
      if (stickyBtn) stickyBtn.disabled = !v.available;
      var ppBtn = document.querySelector("[data-paypal-atc]"); if (ppBtn) ppBtn.disabled = !v.available;
      if (stickyPrice) stickyPrice.textContent = money(v.price);
      var vThumb = v.featured_media && v.featured_media.id ? document.querySelector('[data-media-thumb][data-media-id="' + v.featured_media.id + '"]') : null;
      if (!vThumb) vThumb = document.querySelector("[data-product-media] [data-media-thumb]");
      if (vThumb) vThumb.click();
      if (history.replaceState) {
        var url = new URL(location.href);
        url.searchParams.set("variant", v.id);
        history.replaceState({}, "", url);
      }
    }
    // Verfügbarkeit je Option: Werte ohne passende Variante (zu den übrigen Auswahlen) sind nicht wählbar.
    // Beispiel: Größe „24 cm“ gibt es nur in Gelb → bei 24 cm sind alle anderen Farben gesperrt.
    var optionNames = [];
    root.querySelectorAll("fieldset[data-option]").forEach(function (fs) { optionNames.push(fs.dataset.option); });
    function variantMatches(v, sel) {
      return optionNames.every(function (n, i) { return sel[n] === undefined || v.options[i] === sel[n]; });
    }
    function selectChip(chip) {
      selected[chip.dataset.option] = chip.dataset.value;
      root.querySelectorAll('[data-option-chip][data-option="' + chip.dataset.option + '"]').forEach(function (c) { c.setAttribute("aria-pressed", "false"); c.setAttribute("aria-checked", "false"); });
      chip.setAttribute("aria-pressed", "true");
      chip.setAttribute("aria-checked", "true");
    }
    // Nach einer Wahl: passt die Kombination nicht (z. B. Pink + 24 cm), springen die anderen Optionen
    // auf die erste Variante mit dem gewählten Wert (24 cm → Gelb). Danach werden alle Werte markiert,
    // die zur aktuellen Auswahl nicht existieren – anklickbar bleiben sie, ein Klick springt wieder passend um.
    function reconcile(changedOption) {
      if (optionNames.length < 2 || !changedOption) return;
      var sel = {}; Object.keys(selected).forEach(function (k) { sel[k] = selected[k]; });
      if (variants.some(function (v) { return variantMatches(v, sel); })) return;
      var idx = optionNames.indexOf(changedOption);
      var match = variants.find(function (v) { return v.options[idx] === selected[changedOption] && v.available; }) || variants.find(function (v) { return v.options[idx] === selected[changedOption]; });
      if (!match) return;
      optionNames.forEach(function (name, i) {
        if (name === changedOption) return;
        var chip = root.querySelector('[data-option-chip][data-option="' + name + '"][data-value="' + String(match.options[i]).replace(/"/g, '\\"') + '"]');
        if (chip) selectChip(chip);
      });
    }
    function refreshAvailability() {
      if (optionNames.length < 2) return;
      optionNames.forEach(function (name) {
        root.querySelectorAll('[data-option-chip][data-option="' + name + '"]').forEach(function (c) {
          var sel = {}; Object.keys(selected).forEach(function (k) { sel[k] = selected[k]; });
          sel[name] = c.dataset.value;
          var ok = variants.some(function (v) { return variantMatches(v, sel); });
          c.classList.toggle("is-unavailable", !ok);
          c.setAttribute("aria-disabled", ok ? "false" : "true");
        });
      });
    }
    // Farbwelt: gewählte Farbe tönt Hintergrund, Glow und Szene der Produktseite.
    var worldEls = Array.prototype.slice.call(document.querySelectorAll('[style*="--s-g1"]'));
    var worldOrig = worldEls.map(function (el) { return el.getAttribute("style"); });
    function mix(hex, t) {
      var h = hex.replace("#", ""); if (h.length === 3) h = h.split("").map(function (x) { return x + x; }).join("");
      var n = parseInt(h, 16); var r = (n >> 16) & 255, g = (n >> 8) & 255, b = n & 255;
      var m = function (c) { return Math.round(c + (255 - c) * t); };
      return "#" + [m(r), m(g), m(b)].map(function (c) { return c.toString(16).padStart(2, "0"); }).join("");
    }
    function isPale(hex) {
      var h = String(hex || "").replace("#", ""); if (h.length === 3) h = h.split("").map(function (x) { return x + x; }).join("");
      var n = parseInt(h.slice(0, 6), 16); if (!isFinite(n)) return false;
      var r = ((n >> 16) & 255) / 255, g = ((n >> 8) & 255) / 255, b = (n & 255) / 255;
      var mx = Math.max(r, g, b), mn = Math.min(r, g, b), l = (mx + mn) / 2, d = mx - mn;
      var s = d === 0 ? 0 : d / (1 - Math.abs(2 * l - 1));
      return s < 0.3 || l > 0.82;
    }
    function fixButtonColors() {
      document.querySelectorAll("[data-add-to-cart], [data-sticky-add]").forEach(function (b) {
        b.style.removeProperty("--p-primary"); b.style.removeProperty("color");
        var c = getComputedStyle(b).getPropertyValue("--p-primary").trim();
        if (isPale(c)) { b.style.setProperty("--p-primary", "#FF4F7B"); b.style.setProperty("color", "#fff"); }
      });
    }
    function applyVariantColor() {
      var chip = root.querySelector('[data-option-chip][aria-checked="true"][data-color]:not([data-color=""])');
      var color = chip && chip.dataset.color;
      worldEls.forEach(function (el, i) {
        el.setAttribute("style", worldOrig[i] || "");
        if (!color) return;
        el.style.setProperty("--p-primary", color);
        el.style.setProperty("--p-glow", mix(color, 0.45));
        el.style.setProperty("--p-surface", mix(color, 0.9));
        el.style.setProperty("--p-surface-alt", mix(color, 0.8));
        el.style.setProperty("--s-g1", mix(color, 0.35));
        el.style.setProperty("--s-g2", mix(color, 0.7));
        el.style.setProperty("--s-g3", mix(color, 0.85));
        el.style.setProperty("--s-light1", mix(color, 0.2));
        el.style.setProperty("--s-fluid", mix(color, 0.6));
      });
      fixButtonColors();
    }
    root.querySelectorAll("[data-option-chip]").forEach(function (chip) {
      chip.addEventListener("click", function () {
        selectChip(chip);
        reconcile(chip.dataset.option);
        refreshAvailability();
        update();
        applyVariantColor();
      });
    });
    refreshAvailability();
    applyVariantColor();
    root.querySelectorAll("[data-qty-minus]").forEach(function (b) { b.addEventListener("click", function () { qtyInput.value = Math.max(1, Number(qtyInput.value) - 1); }); });
    root.querySelectorAll("[data-qty-plus]").forEach(function (b) { b.addEventListener("click", function () { qtyInput.value = Number(qtyInput.value) + 1; }); });

    // Galerie (Thumbs, Pfeile, Zähler, Lightbox). Die Bilder stehen in einer eigenen Section
    // (product-hero.liquid) und liegen NICHT innerhalb von [data-product] (der Kaufspalte).
    // Deshalb wird hier vom Medien-Container aus gesucht, sonst greift kein Klick.
    var media = document.querySelector("[data-product-media]") || root;
    var stage = media.querySelector("[data-media-stage]");
    var thumbs = Array.prototype.slice.call(media.querySelectorAll("[data-media-thumb]"));
    var counter = media.querySelector("[data-media-counter]");
    var lightbox = media.querySelector("[data-lightbox]") || document.querySelector("[data-lightbox]");
    var stageControls = stage ? Array.prototype.slice.call(stage.querySelectorAll(".stage-zoom, .stage-nav")) : [];
    function activeIndex() { return Math.max(0, thumbs.findIndex(function (t) { return t.getAttribute("aria-current") === "true"; })); }
    function showMedia(t) {
      thumbs.forEach(function (x) { x.setAttribute("aria-current", "false"); });
      t.setAttribute("aria-current", "true");
      var tpl = media.querySelector('template[data-media-template="' + t.dataset.mediaId + '"]');
      if (stage && tpl) {
        stage.querySelectorAll(":scope > :not(.pdp-stage-bg):not(.stage-zoom):not(.stage-nav):not(.abs-tl)").forEach(function (n) { n.remove(); });
        var frag = document.createElement("div"); frag.innerHTML = tpl.innerHTML;
        Array.prototype.slice.call(frag.childNodes).forEach(function (n) { stage.insertBefore(n, stageControls[0] || null); });
        stage.classList.toggle("is-cutout", t.dataset.mediaId === "cutout"); stage.classList.toggle("is-media", t.dataset.mediaId !== "cutout");
        var vid = stage.querySelector("video"); if (vid) vid.play().catch(function () {});
      }
      if (counter) counter.textContent = (thumbs.indexOf(t) + 1) + " / " + thumbs.length;
      if (lightbox && lightbox.open) fillLightbox();
    }
    function fillLightbox() {
      var t = thumbs[activeIndex()]; if (!lightbox || !t) return;
      var img = lightbox.querySelector("[data-lightbox-img]"); var cap = lightbox.querySelector("[data-lightbox-caption]");
      var src = t.dataset.mediaSrc || (t.querySelector("img") && t.querySelector("img").currentSrc);
      if (img && src) { img.src = src; img.alt = t.getAttribute("aria-label") || ""; }
      if (cap) cap.textContent = (t.getAttribute("aria-label") || "") + " · " + (activeIndex() + 1) + " / " + thumbs.length;
    }
    thumbs.forEach(function (t) { t.addEventListener("click", function () { showMedia(t); }); });
    media.querySelectorAll("[data-media-step]").forEach(function (b) {
      b.addEventListener("click", function (e) { e.stopPropagation(); if (!thumbs.length) return; var i = (activeIndex() + Number(b.dataset.mediaStep) + thumbs.length) % thumbs.length; showMedia(thumbs[i]); });
      b.addEventListener("pointerdown", function (e) { e.stopPropagation(); });
    });
    // Zoom-Buttons liegen in beiden Bereichen: Kaufspalte und Medien-Container.
    function onLightboxClick(e) {
      var open = e.target.closest("[data-lightbox-open]");
      if (open && lightbox && typeof lightbox.showModal === "function") { e.preventDefault(); fillLightbox(); lightbox.showModal(); }
      if (e.target.closest("[data-lightbox-close]") && lightbox) lightbox.close();
    }
    root.addEventListener("click", onLightboxClick);
    if (media !== root) media.addEventListener("click", onLightboxClick);
    if (lightbox) {
      lightbox.addEventListener("click", function (e) { if (e.target === lightbox || e.target.classList.contains("lightbox")) lightbox.close(); });
      lightbox.addEventListener("keydown", function (e) { if (e.key === "ArrowRight" || e.key === "ArrowLeft") { var i = (activeIndex() + (e.key === "ArrowRight" ? 1 : -1) + thumbs.length) % thumbs.length; showMedia(thumbs[i]); } });
    }

    // Sticky ATC (mobil): sichtbar, wenn Haupt-Button außerhalb
    var sticky = root.querySelector("[data-sticky-atc]");
    if (sticky && btn && "IntersectionObserver" in window) {
      var io = new IntersectionObserver(function (entries) { sticky.classList.toggle("show", !entries[0].isIntersecting); sticky.setAttribute("aria-hidden", String(entries[0].isIntersecting)); });
      io.observe(btn);
      if (stickyBtn) stickyBtn.addEventListener("click", function () { btn.click(); });
    }
    update();
  });

  // Videos nur laden, wenn sichtbar
  if ("IntersectionObserver" in window) {
    var vio = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var v = e.target;
        if (e.isIntersecting) { if (v.dataset.src && !v.src) v.src = v.dataset.src; v.play().catch(function () {}); } else v.pause();
      });
    }, { rootMargin: "200px" });
    document.querySelectorAll("video[data-lazy]").forEach(function (v) { vio.observe(v); });
  }
})();

/* Upsell „3 kaufen, 2 zahlen“: aktuelles Produkt + zwei gewählte Produkte zusammen in den Warenkorb.
   Der Rabatt (günstigstes gratis) kommt aus dem automatischen Shopify-Rabatt. */
(function () {
  "use strict";
  document.querySelectorAll("[data-upsell]").forEach(function (box) {
    var btn = box.querySelector("[data-upsell-add]");
    var form = document.querySelector("form[data-product-form]");
    if (!btn || !form) return;
    btn.addEventListener("click", function () {
      var main = form.querySelector("[data-variant-id]");
      var items = [];
      if (main && main.value) items.push({ id: Number(main.value), quantity: 1 });
      box.querySelectorAll("[data-upsell-select]").forEach(function (s) { if (s.value) items.push({ id: Number(s.value), quantity: 1 }); });
      if (items.length < 3) { box.querySelector("[data-upsell-select]:not([value]), [data-upsell-select]").focus(); box.classList.add("needs-choice"); return; }
      box.classList.remove("needs-choice");
      btn.disabled = true;
      fetch("/cart/add.js", { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify({ items: items }) })
        .then(function (r) { if (!r.ok) throw r; return r.json(); })
        .then(function () {
          if (window.squishCart) { window.squishCart.ensureReservation(); return window.squishCart.refresh().then(function () { window.squishCart.open(); }); }
          location.href = "/cart";
        })
        .catch(function (err) { if (err && err.json) err.json().then(function (j) { alert(j.description || j.message || "Error"); }); })
        .finally(function () { btn.disabled = false; });
    });
  });
})();
